export enum SearchFilterProfessionalGenderType {
  ALL = 'ALL',
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface ProfessionalGenderOptionsProps {
  value: SearchFilterProfessionalGenderType;
  title: string;
}

export const SearchFilterProfessionalGenderMap: Record<SearchFilterProfessionalGenderType, string> = {
  [SearchFilterProfessionalGenderType.ALL]: 'Todos',
  [SearchFilterProfessionalGenderType.MALE]: 'Homens',
  [SearchFilterProfessionalGenderType.FEMALE]: 'Mulheres',
};
